module.exports = __webpack_public_path__ + "static/media/app-logo.d8e0d622.svg";